import React from "react";
import testboxImg from "../../Assets/test-box-img.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TestBox = () => {
  const { t } = useTranslation('home');
  return (
    <section className="mx-12 mb-12 mt-20 md-max:my-10 md-max:mx-6 pl-20 md-max:px-10 x:py-10 py-24 pr-12 flex md-max:flex-col justify-between items-center border border-blue-400 rounded-2xl">
      <div className=" w-1/2 flex flex-col gap-6 md-max:w-full">
        <p className="text-gradient font-semibold text-5xl md-max:text-3xl">
          {t('testbox.title')}
        </p>
        <p className="text-gradient text-base">
          {t('testbox.description')}
        </p>
        <Link to="/home">
          <button className="bg-gradient-to-br from-[#1F6AFF] to-[#27BEFA] w-max px-4 py-2.5 rounded-xl text-white font-medium hover:shadow-lg">
            {t('testbox.button')}
          </button>
        </Link>
      </div>
      <div className="w-1/2 flex justify-end md-max:justify-center md-max:w-full">
      <img src={testboxImg} alt="uslot" className="object-cover rounded-2xl" />
      </div>
    </section>
  );
};

export default TestBox;
